<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        v-bind="attrs"
        v-on="on"
        icon
        class="text-capitalize mr-3 colorYellow1"
        color="defaultColor"
      >
        <v-icon size="30">mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        link
        v-for="(item, i) in menuItems"
        :key="i"
        @click="clickEvent(item.key)"
      >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import PostService from "../../services/PostService.js";
import { mapActions } from "vuex";
export default {
  props: {
    itemData: {
      type: Object,
      required: true,
    },
  },
  components: {},
  data: function () {
    {
      return {
        adminItems: [
          { title: this.$i18n.t("menu.delete"), key: "delete" },
          { title: this.$i18n.t("menu.update"), key: "update" },
          { title: this.$i18n.t("menu.pinOne"), key: "pinOne" },
          { title: this.$i18n.t("menu.pinTwo"), key: "pinTwo" },
          { title: this.$i18n.t("menu.pinThree"), key: "pinThree" },
        ],
        adminPinnedItems: [
          { title: this.$i18n.t("menu.delete"), key: "delete" },
          { title: this.$i18n.t("menu.update"), key: "update" },
          { title: this.$i18n.t("menu.deletePin"), key: "deletePin" },
        ],
        standartItems: [{ title: this.$i18n.t("menu.report"), key: "report" }],
        meItems: [
          { title: this.$i18n.t("menu.delete"), key: "delete" },
          { title: this.$i18n.t("menu.update"), key: "update" },
        ],
      };
    }
  },
  methods: {
    clickEvent(type) {
      console.log("type :", type);
      switch (type) {
        case "delete":
          this.deletePost();
          break;
        case "report":
          this.reportPost();
          break;
        case "update":
          this.updatePost();
          break;
        case "deletePin":
          this.removePinPost();
          break;
        case "pinOne":
          this.pinPost(1);
          break;
        case "pinTwo":
          this.pinPost(2);
          break;
        case "pinThree":
          this.pinPost(3);
          break;
        default:
          break;
      }
    },

    deletePost() {
      PostService.deletePost(this.itemData.Id)
        .then((res) => {
          showSuccess(this.$t("description.successDeleteContent"));
          this.getPosts();
        })
        .catch(async (err) => {
          console.log("err :", err);
          showError(err);
        })
        .then(() => {});
    },

    updatePost() {
      this.setUpdateDialogItem(this.itemData)
      setTimeout(() => {
        this.$store.state.createDialogStatus = true
      }, 100);
      
    },

    reportPost() {
      const body = {
        RelatedEntityId: this.itemData.Id,
        RelatedEntityType: "post",
        Reason: {
          Id: "722d14a5cd3a7547af4cb612",
          Reason: "Diğer",
          ReasonType: "post",
          Status: 0,
          IsAllGroups: false,
        },
      };
      PostService.complainPost(body)
        .then((res) => {
          showSuccess(this.$t("description.successReport"));
        })
        .catch(async (err) => {
          console.log("err :", err);
          showError(err);
        })
        .then(() => {});
    },

    removePinPost() {
      PostService.unPinPost(this.itemData.Id)
        .then((res) => {
          showSuccess(this.$t("description.successDeletePin"));
          this.getPosts();
        })
        .catch((err) => {
          console.log("err :", err);
          showError(err);
        })
        .then(() => {});
    },

    pinPost(pinType) {
      PostService.pinPost(this.itemData.Id, pinType)
        .then((res) => {
          this.getPosts().then(() => {
            showSuccess(this.$t("description.successPin"));
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          });
        })
        .catch((err) => {
          console.log("err :", err);
          showError(err);
        })
        .then(() => {});
    },

    ...mapActions(["getPosts", "setUpdateDialogItem"]),
  },
  watch: {},
  computed: {
    menuItems() {
      if (this.$store.state.user.Type.toLowerCase() != "standart") {
        if (this.itemData.IsPinned) return this.adminPinnedItems;
        else return this.adminItems;
      } else {
        if (this.$store.state.user.Id == this.itemData.User.Id) {
          return this.meItems;
        } else {
          return this.standartItems;
        }
      }
    },
  },
};
</script>

<style></style>
